export const OTHER_DEFERRAL_REASON_ID = 'other'; // See also `deferral_reason.rb`
